import $ from 'jquery';
import {nextFrame} from '../Libraries/Utils';
import Swiper from 'swiper';
import {Navigation, Autoplay} from 'swiper/modules';

$(document).on('click', '.text-image__image:has(.text-image__image-poster[data-video])', ev => {
    ev.preventDefault();
    const $image = $(ev.currentTarget);
    const $poster = $image.find('.text-image__image-poster');
    const $parent = $image.parent();

    (async () => {
        const html = $poster.attr('data-video');
        $image.replaceWith(html);
        await nextFrame();
        await nextFrame();
        const $video = $parent.find('video');
        if ($video.length > 0) {
            const video = $video[0];
            video.play();
        }
    })();
});

$(document).on('click', '.text-image__video, .text-image__image--type-4', ev => {
    const video = ev.target.closest('.text-image__video, .text-image__image--type-4');
    if (!video) return;

    if (video.paused) {
        video.play();
    } else {
        video.pause();
    }
});

$('.text-image--has-multiple-images').each((_, elem) => {
    const $root = $(elem);

    const $slider = $root.find('.text-image__image-holder .swiper');
    const next = $root.find('.text-image__nav .swiper-arrow--next')[0];

    let config = {
        modules: [Navigation, Autoplay],
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: next,
        },
    };

    if ($slider.find('.text-image__image-poster[data-video]').length > 0) {
        config.modules = [Navigation];
        delete config.autoplay;
    }

    const slider = new Swiper($slider[0], config);

});

